import { RecordFolderAssignment } from '@provision/entity-types';
import { QueryHookOptions, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { UPDATE_RECORD_FOLDER_ASSIGNMENT_QUERY } from 'src/graphql/entities/record-folder-assignment/record-folder-assignment.operations';

export interface UpdateRecordFolderAssignment {
  updateRecordFolderAssignment: RecordFolderAssignment[];
}

export const useUpdateRecordFolderAssignment = () => {
  const [updateRecordFolderAssignment, { loading: isLoading }] =
    useMutation<UpdateRecordFolderAssignment>(UPDATE_RECORD_FOLDER_ASSIGNMENT_QUERY);

  const updateWithOptimisticResponse = useCallback(
    (
      original: RecordFolderAssignment,
      patch: Partial<RecordFolderAssignment>,
      onCompleted?: QueryHookOptions['onCompleted'],
    ) => {
      void updateRecordFolderAssignment({
        variables: {
          data: patch,
          recordFolderAssignmentId: original.id || original.recordFolderAssignmentId,
        },
        optimisticResponse: {
          updateRecordFolderAssignment: [
            {
              ...original,
              ...patch,
            },
          ],
        },
        onCompleted,
        context: {
          omitIsolationModeHeader: true,
        },
      });
    },
    [updateRecordFolderAssignment],
  );

  return {
    updateRecordFolderAssignment: updateWithOptimisticResponse,
    isLoading,
  };
};
